import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { EcomProd } from 'src/app/shared/classes/product';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { OrderService } from 'src/app/shared/services/order.service';
import { response } from 'express';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { HttpClient } from '@angular/common/http';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { DatePipe } from '@angular/common';
import * as moment from 'moment'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { link } from 'fs';
import { json, text } from 'stream/consumers';
import { image } from 'html2canvas/dist/types/css/types/image';
import { content } from 'html2canvas/dist/types/css/property-descriptors/content';
import { borderBottomLeftRadius, borderBottomRightRadius } from 'html2canvas/dist/types/css/property-descriptors/border-radius';
import { borderBottomStyle } from 'html2canvas/dist/types/css/property-descriptors/border-style';
import { color } from 'html2canvas/dist/types/css/types/color';
import { ExternalService } from 'src/app/shared/services/external.service';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { ToastrService } from 'ngx-toastr';
import { ProductService } from 'src/app/shared/services/product.service';
import { Width } from 'ngx-owl-carousel-o/lib/services/carousel.service';
import { MyService } from 'src/app/shared/services/myservice';

@Component({
  selector: 'app-order-management',
  templateUrl: './order-management.component.html',
  styleUrl: './order-management.component.scss',
  animations: [
    trigger('slideInOut', [
      state('in', style({
        transform: 'translate3d(0,0,0)'
      })),
      state('out', style({
        transform: 'translate3d(100%, 0, 0)'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out'))
    ]),
  ]
})


export class OrderManagementComponent implements OnInit {

  Order: any = []
  Auth: any;
  savedfilename: any;
  sanitizer: any;
  blobimageurl: any;
  @ViewChild('paymentModal', { static: true }) paymentModal: ElementRef<any>
  constructor(private router: Router, private orderservice: OrderService,
    private http: HttpClient, private modalService: NgbModal,
    private toastrService: ToastrService, private externalService: ExternalService, public productService: ProductService, private myService: MyService
  ) {
    // this.getPosition().then(pos => {
    //   console.log(pos);
    // });


    // this.orderservice.Orderget.subscribe(response => {
    //   console.log(response)
    //   this.Order = response['orders']
    //   this.Order.j.forEach(data => {
    //     data.options.forEach(element => {
    //       data.product.Total = ((data.weight.price + (data.weight.qty * (element.addons.price || 0) + data.weight.qty * (element.variants.price || 0))))
    //     });
    //   })
    //   console.log(this.Order)
    // })
    // this.getorders()
    router.events
      .subscribe((event: NavigationStart) => {
        if (event.navigationTrigger === 'popstate') {
          this.router.navigate(['home/fashion']);
        }
      });
  }

  public ecomproduct: EcomProd = {};
  public mobileSidebar: boolean = false;
  public Ofiltid: number = 0;

  img = 'https://i.postimg.cc/DzT0mN79/fblogo.png'

  ngOnInit(): void {
    // this.getorders();
    this.myService.HearderId.next(2);
    this.Ofiltid = 0;
    this.rating
    this.GetEcomOrders()
    this.getipadd()




    // function getGoogleMapsURL(address) {
    //   const encodedAddress = encodeURIComponent(address);
    //   const baseURL = "https://www.google.com/maps/place/";
    //   const location = `${baseURL}${encodedAddress}`;


    //   console.log("Google Maps Location URL:", location);
    //   return location;
    // }

    // // Usage example
    // // const address = "60, RGM Complex, OMR, Rajiv Gandhi Salai, Karapakkam, Chennai, Tamil Nadu 600097";
    // const address = "3/338, marketroad , kelambakkam, 603103";

    // const locationURL = getGoogleMapsURL(address);

    // console.log(locationURL)

    // this.getPosition().then(pos => {
    //   console.log(pos);
    // });

    // function getBase64Image(url, callback) {
    //   const img = new Image();
    //   img.crossOrigin = 'Anonymous'; 

    //   img.onload = function () {
    //     const canvas = document.createElement('canvas');
    //     canvas.width = 200;
    //     canvas.height = 200;
    //     const ctx = canvas.getContext('2d');

    //     if (ctx) {
    //       ctx.drawImage(img, 0, 0);
    //       const dataURL = canvas.toDataURL('image/png');
    //       callback(dataURL);
    //     }
    //   };

    //   img.onerror = function () {

    //   };

    //   img.src = url;
    // }


    // getBase64Image('https://i.postimg.cc/DzT0mN79/fblogo.png', function (base64Image) {
    //   // console.log(base64Image); 
    // });


  }
  hidval: boolean = false
  posOrder: any = []
  GetEcomOrders() {
    document.getElementById('orderload').style.display = 'block'
    this.orderservice.OrdergetEcom.subscribe(response => {
      // console.log(response)
      if (response["status"]) {
        document.getElementById('orderload').style.display = 'none'
        this.Order = response['orderData'];

        this.Order.forEach(element => {
          element.j = JSON.parse(element.j);
        });
        this.hidval = true
        // console.log(this.Order)


      } else {
        this.hidval = true
      }
    })
  }




  getorders() {
    // this.orderservice.Orderget.subscribe(response => {
    //   // console.log(response);

    //   if (response['status'] == 200) {
    //     this.Order = response['orders'];
    //     this.Order.forEach(element => {
    //       element.n = JSON.parse(element.n)
    //     });

    //     if (this.Order == '') {
    //       this.hidval = false
    //     }
    //     // console.log(this.Order)

    //     setTimeout(() => {
    //       document.getElementById('preloaderom').style.display = 'none'
    //     }, 1300);
    //   } else {
    //     this.hidval = true
    //   }

    // });
  }

  // index:any = [{Id:1},{Id:2},{Id:3},{Id:4},{Id:5}]


  PendingOrder: any = []
  public hide: boolean = false
  public mainhide: boolean = false
  OrdStatusID: number = -100
  hidetrack: boolean = true

  timeExpire: boolean = false
  CouperordArray: any = []
  getDetails(OrderById, OrdStsId) {
    // console.log(OrderById, OrdStsId)
    this.orderservice.GetorderById(OrderById)
    this.orderservice.OrdergetbyId.subscribe(response => {
      // console.log(response)
      if (response["status"] == 200) {
        this.PendingOrder = response['orders'][0];
        this.posOrder = response['posorder'];
        // console.log(this.posOrder)
        // console.log(this.PendingOrder)
        this.CouperordArray = response['orders'];

        this.CouperordArray.forEach(ord => {
          if (ord.osi == 5 && ord.pti == 1) {
            const payload = {
              orderid: this.posOrder[0].posId,
              customerid: ord.cui,
              products: ord.j
                .map(item => ({
                  categoryid: item.product.catId,
                  productid: item.product.id

                }))
                .filter(prod => prod.categoryid !== 308) // Remove categoryid 308
            };
            this.externalService.savecoopen(payload).subscribe(data => {
              // console.log(data);
            });
          }
        });

        const currentTime = new Date();
        const didtTime = new Date(this.PendingOrder.didt);

        // Calculate one hour before the `didt` time
        const oneHourBeforeDidt = new Date(didtTime);
        oneHourBeforeDidt.setHours(oneHourBeforeDidt.getHours() - 1);

        if (currentTime < oneHourBeforeDidt) {
          // console.log("<p>cancelorder</p>");
          this.timeExpire = false
        } else {
          // console.log("Not allowed to cancel");
          this.timeExpire = true
        }

        // console.log(this.PendingOrder)
        // console.log(OrderById, OrdStsId)
        if (OrdStsId == 5) {
          this.hidecancelbtn = false
        }
        if (OrdStsId == -1) {
          this.hidecancelbtn = false
        }
        this.OrdStatusID = OrdStsId
        if (this.OrdStatusID == 0) {

          // this.PendingOrder = this.Order.filter(x => x.Id == OrderById)[0]
          this.PendingOrder.txa = Math.ceil(this.PendingOrder.txa)
          this.PendingOrder.subTotal = Math.round(this.PendingOrder.ta - this.PendingOrder.txa)
          // console.log(this.PendingOrder)
          setTimeout(() => {
            this.nextStep(OrdStsId)
          }, 50);
          if (this.trackordhide == true) {
            setTimeout(() => {
              this.nextStep2(OrdStsId)
            }, 50);
          }
          this.hide = false
          this.mainhide = true
        }
        if (this.OrdStatusID > 0) {
          if (OrdStsId == 1) {
            // this.PendingOrder = this.Order.filter(x => x.Id == OrderById)[0]
            // console.log(this.PendingOrder)
            this.PendingOrder.txa = Math.ceil(this.PendingOrder.txa)
            this.PendingOrder.subTotal = Math.round(this.PendingOrder.ta - this.PendingOrder.txa)
            setTimeout(() => {
              this.nextStep(OrdStsId)
            }, 50);
            if (this.trackordhide == true) {
              setTimeout(() => {
                this.nextStep2(OrdStsId)
              }, 50);
            }
            this.hide = false
            this.mainhide = true
          }
          if (OrdStsId > 1) {
            // this.PendingOrder = this.Order.filter(x => x.Id == OrderById)[0]
            this.PendingOrder.txa = Math.ceil(this.PendingOrder.txa)
            this.PendingOrder.subTotal = Math.round(this.PendingOrder.ta - this.PendingOrder.txa)
            setTimeout(() => {
              this.nextStep(OrdStsId)
            }, 50);
            if (this.trackordhide == true) {
              setTimeout(() => {
                this.nextStep2(OrdStsId)
              }, 50);
            }
            this.hide = false
            this.mainhide = true
          }
        }

        if (this.OrdStatusID == -1 || -5) {
          // this.PendingOrder = this.Order.filter(x => x.Id == OrderById)[0]
          // console.log(this.PendingOrder)
          this.PendingOrder.txa = Math.ceil(this.PendingOrder.txa)
          this.cancelreason = this.PendingOrder.n.cancel_status
          this.PendingOrder.subTotal = Math.round(this.PendingOrder.ta - this.PendingOrder.txa)
          this.hide = false
          this.mainhide = true
        }

        // if (this.OrdStatusID > 0) {
        let ordcoupAmt = 0;
        // console.log(this.PendingOrder)
        this.PendingOrder.j.forEach(element => {
          if (element.product.coupons !== null) {
            element.product.coupAmt = element.product.coupons.couponamount
            ordcoupAmt += element.product.coupons.couponamount || 0
          }

        });
        this.PendingOrder.txa = Math.ceil(this.PendingOrder.txa)

        this.PendingOrder.ordcoupAmt = Math.ceil(ordcoupAmt)
        // }
        // console.log("Total Coupon Amount:", ordcoupAmt);
        // console.log(this.PendingOrder)


      }
    })


  }

  back() {
    this.OrdStatusID = -100
    this.hide = false
    this.mainhide = false
    // window.location.reload()
    // this.getorders()
    this.PendingOrder = []
    this.cancelreason = ''
  }

  currentStep = 1;
  numSteps = 10;

  stepper: any
  steps: any
  stepper2: any
  steps2: any

  nextStep2(Id) {
    // console.log(Id)

    Id++;
    // if (Id > this.numSteps) {
    //   // Id = 2;
    // }

    const stepper2 = document.getElementById("stepper2");
    const steps2 = stepper2 && stepper2.getElementsByClassName("step");
    this.stepper2 = stepper2
    this.steps2 = steps2


    // const stepper = document.getElementById("stepper1");
    // const steps = stepper.getElementsByClassName("step");
    // console.log(this.stepper, this.steps)

    Array.from(this.steps2).forEach((step, index) => {
      // console.log(step, index)
      let stepNum = index + 1;
      // console.log(stepNum)

      if (stepNum === Id) {
        this.addClass(step, "editing");
      } else {
        this.removeClass(step, "editing");
      }
      if (stepNum < Id) {
        this.addClass(step, "done");
      } else {
        this.removeClass(step, "done");
      }
    });
  }

  nextStep(Id) {
    // console.log(Id)

    Id++;
    // if (Id > this.numSteps) {
    //   // Id = 2;
    // }

    const stepper = document.getElementById("stepper1");
    const steps = stepper && stepper.getElementsByClassName("step");
    this.stepper = stepper
    this.steps = steps


    // const stepper = document.getElementById("stepper1");
    // const steps = stepper.getElementsByClassName("step");
    // console.log(this.stepper, this.steps)

    Array.from(this.steps).forEach((step, index) => {
      // console.log(step, index)
      let stepNum = index + 1;
      // console.log(stepNum)

      if (stepNum === Id) {
        this.addClass(step, "editing");
      } else {
        this.removeClass(step, "editing");
      }
      if (stepNum < Id) {
        this.addClass(step, "done");
      } else {
        this.removeClass(step, "done");
      }
    });
  }
  hasClass(elem, className) {
    return new RegExp(" " + className + " ").test(" " + elem.className + " ");
  }

  addClass(elem, className) {
    if (!this.hasClass(elem, className)) {
      elem.className += " " + className;
    }
  }

  removeClass(elem, className) {
    var newClass = " " + elem.className.replace(/[\t\r\n]/g, " ") + " ";
    if (this.hasClass(elem, className)) {
      while (newClass.indexOf(" " + className + " ") >= 0) {
        newClass = newClass.replace(" " + className + " ", " ");
      }
      elem.className = newClass.replace(/^\s+|\s+$/g, "");
    }
  }

  hideDetails: boolean = false

  Detailshide() {
    this.hideDetails = false
  }

  Detailsshow() {
    this.hideDetails = true
  }

  trackordhide: boolean = false

  Trackhide() {
    this.trackordhide = false
  }

  Trackshow() {
    this.trackordhide = true
    // console.log(id)
    // console.log(this.OrdStatusID)
    // this.nextStep(id)
    setTimeout(() => {
      this.nextStep2(this.OrdStatusID)
      // ...
    }, 50);
    this.drowopen();
  }

  shopmore() {
    this.router.navigate(['/home/fashion']);
  }


  sorting(event) {
    this.orderservice.GetOrders(this.Ofiltid)
    this.GetEcomOrders()
    document.getElementById('preloaderom').style.display = 'block'
    // console.log("O sort::::2", this.Ofiltid);

    setTimeout(() => {
      document.getElementById('preloaderom').style.display = 'none'
    }, 2000);

  }

  menuState: string = 'out';
  drowopen() {
    setTimeout(() => {
      this.nextStep2(this.OrdStatusID)
      // ...
    }, 50);
    this.menuState = this.menuState === 'out' ? 'in' : 'out';
    // console.log("this.menuState::::", this.menuState)
  }

  isDownloading = false;




  pdfUrlBlob =
    'https://staging.safegold.com/display/sales-invoice/da771e90-aa8f-4147-bc7c-805b73bb1283';

  downlaodBlobPDF() {
    this.isDownloading = true;
    this.http.get(this.pdfUrlBlob, { responseType: 'arraybuffer' }).subscribe(
      (pdf) => {

        const newBlob = new Blob([pdf], { type: 'application/pdf' });
        const a = document.createElement('a');
        a.target = '_self';
        const fileName = 'pdf_file.pdf';
        const data = window.URL.createObjectURL(newBlob);
        a.href = data;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        this.isDownloading = false;
      },
      (err) => {
        // console.log('err->', err);
      }
    );
  }

  // @ViewChild('content', { static: false }) content: ElementRef;


  // public downloadPDF(): void {
  //   const doc = new jsPDF();

  //   const specialElementHandlers = {
  //     '#editor': function (element, renderer) {
  //       return true;
  //     }
  //   };

  //   const content = this.content.nativeElement.innerHTML;

  //   doc.html(content, {
  //     width: 100, callback: (doc) => {
  //       doc.save('test.pdf');
  //     }
  //   });
  // }
  paylink: string = '';
  proceedToPayment() {
    // console.log(this.PendingOrder);
    this.paylink = '';

    const payload = {
      cui: this.PendingOrder?.cui,
      orderId: this.PendingOrder?.Id,
      ta: this.PendingOrder?.ta
    };

    this.productService.PayOnline(payload).subscribe(response => {
      // console.log(response);
      this.paylink = response.root;

      if (this.paylink) {
        this.modalService.open(this.paymentModal, { centered: true, size: 'sm' });
      } else {
        // console.error("Payment link is empty");
      }
    }, error => {
      // console.error("Payment API Error", error);
    });

    // console.log(payload);
  }

  continuePay() {
    if (this.paylink) {
      window.location.href = this.paylink; // Open external payment link
    } else {
      // console.error("No payment link available");
    }
  }


  printhtmlstyle = `
  <style>
    body, html {
      margin: 0;
      padding: 0;
      font-family: 'Inter', sans-serif;
      color: #555;
    }
  
    #printelement {
      max-width: 800px; /* Fixed width for PDF */
      margin: 0 auto;
      border: 1px solid #000;
      padding: 20px;
      box-sizing: border-box;
      background-color: #F9FAFC;
    }
  
    .invoice-container {
      width: 100%;
      padding: 20px;
      border: 1px solid #000;
      box-sizing: border-box;
    }
  
    h11 {
      color: #1A1C21;
      font-size: 18px;
      font-weight: 600;
      text-align: center;
      margin: 0 0 18px 0;
    }
  
    table {
      width: 100%;
      font-size: 12px;
      line-height: 20px;
      border-collapse: collapse;
    }
  
    th, td {
      padding: 8px;
      border-bottom: 1px solid #D7DAE0;
    }
  
    th {
      text-align: left;
      text-transform: uppercase;
      color: #1A1C21;
    }
  
    td {
      color: #5E6470;
    }
  
    .total-table th, .total-table td {
      border: none;
    }
  
    .total-table th {
      text-align: start;
    }
  
    .total-table td {
      text-align: end;
    }
  
    @media (max-width: 768px) {
      #printelement {
        max-width: 100%;
        padding: 10px;
      }
  
      .invoice-container {
        width: 100%;
        padding: 10px;
      }
  
      h11 {
        font-size: 16px;
      }
         .p1{
 font-size: 12px;
        }
  
      th, td {
        padding: 6px;
        font-size: 10px;
      }
  
      th {
        text-align: left;
      }

          .mob1{
      place-content: flex-start;
       width: 20%;
      }
        .mob2{
      place-content: flex-start;
       width: 40%;
      }
        .mob3{
      place-content: flex-start;
       width: 40%;
      }
    }
  
    @media (max-width: 480px) {
      #printelement {
        max-width: 100%;
        padding: 5px;
      }
  
      .invoice-container {
        width: 100%;
        padding: 5px;
      }
        .p1{
 font-size: 12px;
        }
  
      h11 {
        font-size: 14px;
      }
  
      th, td {
        padding: 4px;
        font-size: 8px;
      }
  
      th {
        text-align: left;
      }

      .mob1{
      place-content: flex-start;
       width: 20%;
      }
        .mob2{
      place-content: flex-start;
       width: 40%;
      }
        .mob3{
      place-content: flex-start;
       width: 40%;
      }
  
    }
  </style>`;

  printreceipt() {
    let printtemplate = `
      ${this.printhtmlstyle}
      <div id="printelement" class="invoice-container">
        <h1 class="h11" style="text-align:center">Tax Invoice</h1>
        <table>
          <tbody>
            <tr>
              <td class="mob1" style="    place-content: flex-start;    width: 20%;">
                <p class="p1"  style="font-weight: 700; color: #1A1C21;">Customer Name</p>
                <span>${this.PendingOrder.ca.Name}</span>
              </td>
              <td class="mob2"  style="place-content: flex-start; width: 45%;">
                <p class="p1" style="font-weight: 700; color: #1A1C21;">Billing Address</p>
                <span>${this.PendingOrder.ca.Address}</span>
              </td>
              <td class="mob3"  style="width: 35%;">
                <table class="total-table">
                  <tr>
                    <th>Invoice No</th>
                    <td>#${this.PendingOrder.ino}${this.PendingOrder.Id}</td>
                  </tr>
                  <tr>
                    <th>Ordered date</th>
                    <td>${moment(this.PendingOrder.oddt).format('DD/MM/yyyy hh:mm a')}</td>
                  </tr>
                  <tr>
                    <th>Delivery Date</th>
                    <td>${moment(this.PendingOrder.didt).format('DD/MM/yyyy hh:mm a')}</td>
                  </tr>
                  <tr>
                    <th>GSTIN</th>
                    <td>33AODPM8622B1ZC</td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td colspan="3">
                <table>
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Item</th>
                      <th style="text-align: end;">Qty</th>
                      <th style="text-align: end;">Price</th>
                      <th style="text-align: end;">Amount</th>
                    </tr>
                  </thead>
                  <tbody>`;

    this.PendingOrder.j.forEach((item, i) => {
      printtemplate += `
                    <tr>
                      <td>${i + 1}</td>
                      <td>
                        <p class="p1" style="font-weight: 700; color: #1A1C21;">${item.product.name}${item.product.wg_qtytxt ? item.product.wg_qtytxt : ""}</p>
                        <span>${item.product.v_name ? item.product.v_name : ""}</span>
                      </td>
                      <td style="text-align: end;">${item.product.quantity}</td>
                      <td style="text-align: end;">₹${item.product.prodtotal}</td>
                      <td style="text-align: end;">₹${item.product.prodtotal * item.product.quantity}</td>
                    </tr>`;
    });

    printtemplate += `
                  </tbody>
                  <tfoot style="border-bottom: hidden;">
                    <tr>
                      <td colspan="2"></td>
                      <td colspan="3">
                        <table class="total-table">
                          <tbody>
                            <tr>
                              <th>Subtotal</th>
                              <td>₹${this.PendingOrder.subTotal.toFixed(2)}</td>
                            </tr>
                            <tr>
                              <th>Tax%</th>
                              <td>${this.PendingOrder.txa.toFixed(2)}</td>
                            </tr>
                          </tbody>
                          <tfoot >
                            <tr>
                              <th>Total Price</th>
                              <td>₹${this.PendingOrder.ta.toFixed(2)}</td>
                            </tr>
                          </tfoot>
                        </table>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>`;
    // console.log(printtemplate);

    document.body.insertAdjacentHTML('beforeend', printtemplate);
    const newPrintElement = document.getElementById('printelement');

    if (newPrintElement) {
      html2canvas(newPrintElement).then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF();

        // Get PDF dimensions
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();

        // Calculate the aspect ratio of the canvas
        const aspectRatio = canvas.width / canvas.height;

        // Adjust the canvas size to fit the PDF dimensions while maintaining the aspect ratio
        const canvasWidth = pdfWidth - 20; // Subtract some padding
        const canvasHeight = canvasWidth / aspectRatio;

        // Add the image to the PDF
        pdf.addImage(imgData, 'PNG', 10, 10, canvasWidth, canvasHeight);

        pdf.save(`FBINVO${this.PendingOrder.Id}.pdf`);
        newPrintElement.remove();
      });
    } else {
      // console.error("Print element with id 'printelement' not found.");
    }
  }

  invoice: any;

  generatePDF(action = 'download') {
    // console.log(action)
    // console.log(this.PendingOrder.j)
    let base64Image = 'data:image/png;base64,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'
    let docDefinition = {

      background: function (currentPage, pageSize) {
        return [
          {
            canvas: [
              { type: 'line', x1: 10, y1: 10, x2: 585, y2: 10, lineWidth: 1 }, //Up line
              { type: 'line', x1: 10, y1: 10, x2: 10, y2: 835, lineWidth: 1 }, //Left line
              { type: 'line', x1: 10, y1: 835, x2: 585, y2: 835, lineWidth: 1 }, //Bottom line
              { type: 'line', x1: 585, y1: 10, x2: 585, y2: 835, lineWidth: 1 }, //Rigth line
            ]

          }
        ]
      },

      content: [

        {
          image: base64Image,
          width: 80,
          height: 80,
          alignment: 'left'
        },
        {
          text: 'TAX INVOICE',
          fontSize: 20,
          bold: true,
          alignment: 'center',
          decoration: 'underline',
          margin: [10, -50, 10, -25]
          // color: 'skyblue'
        },
        {

          text: 'Customer Details',
          bold: true,
          decoration: 'underline',
          fontSize: 14,
          margin: [0, 80, 0, 15]
          // margin: [10, 20, 10, 20]
        },
        {
          columns: [
            [
              {
                // text: this.PendingOrder.ca.Name,
                text: this.PendingOrder.ca.Name,
                fontSize: 12,
                bold: true
              },
              // { text: this.PendingOrder.ca.Address },
              { text: this.PendingOrder.ca.Address, Width: "300px" },
              { text: this.PendingOrder.ca.City + '-' + this.PendingOrder.ca.Pincode },
              { text: "Ph :" + this.PendingOrder.ca.PhoneNo },


              // { text: this.invoice.email },
              // { text: this.invoice.contactNo }
            ],
            [
              {
                text: `Invoice No : #${this.PendingOrder.ino}${this.PendingOrder.Id}`,
                // margin: [10, 20, 10, 20],
                alignment: 'right'
              },
              {
                text: `Ordered Date: ${moment(this.PendingOrder.oddt).format('DD/MM/yyyy hh:mm a')}`,
                alignment: 'right'
              },
              {
                text: `Delivery Date: ${moment(this.PendingOrder.didt).format('DD/MM/yyyy hh:mm a')}`,
                alignment: 'right'
              },
              {
                text: `GSTIN: 33AODPM8622B1ZC`,
                alignment: 'right'
              },

            ]
          ]
        },
        {
          text: 'Order Details',
          style: 'sectionHeader'
        },

        {
          // table: {
          //   headerRows: 1,
          //   widths: ['*', 'auto', 'auto', 'auto'],
          //   body: [
          //     ['Name', 'Price', 'Quantity', 'Amount'],
          //     ...this.PendingOrder.j.product.map(p => ([p.v_name, p.prodtotal, p.quantity, (p.prodtotal * p.quantity).toFixed(2)])),
          //     [{ text: 'Total Amount', colSpan: 3 }, {}, {}, this.PendingOrder.j.product.reduce((sum, p) => sum + (p.quantity * p.prodtotal), 0).toFixed(2)]
          //   ]
          // }

          table: {
            headerRows: 1,
            widths: ['10%', '40%', '15%', '15%', '20%'],
            style: 'boldsize',
            body: [
              [
                { text: 'S.No', fontSize: 12, bold: true, alignment: 'center' },
                { text: 'Name', fontSize: 12, bold: true, alignment: 'center' },
                { text: 'Price', fontSize: 12, bold: true, alignment: 'center' },
                { text: 'Quantity', fontSize: 12, bold: true, alignment: 'center' },
                { text: 'Amount', fontSize: 12, bold: true, alignment: 'center' }
              ],
              ...this.PendingOrder.j.map((item, i) => {
                const product = item.product;
                return [{ text: `${i + 1}`, alignment: 'center' }, `${product.name}  ${product.wg_qtytxt ? product.wg_qtytxt : ""} ${item.product.v_name ? item.product.v_name : ""}`, { text: product.prodtotal, alignment: 'right' }, { text: product.quantity, alignment: 'center' }, { text: (product.prodtotal * product.quantity).toFixed(2), alignment: 'right' }];
              }),
              [{ text: 'SubTotal', colSpan: 4, fontSize: 12, bold: false, alignment: 'right' }, {}, {}, {}, { text: this.PendingOrder.j.reduce((sum, item) => sum + (item.product.quantity * item.product.prodtotal), 0).toFixed(2), alignment: 'right', bold: false }],
             [{ text: 'Coupon Savings', colSpan: 4, fontSize: 12, bold: false, alignment: 'right' }, {}, {}, {}, { text: `-${this.PendingOrder.ordcoupAmt.toFixed(2)}`, alignment: 'right', bold: false }],

              [{ text: 'Tax 18%', colSpan: 4, fontSize: 12, bold: false, alignment: 'right' }, {}, {}, {}, { text: `${this.PendingOrder.txa.toFixed(2)}`, alignment: 'right', bold: false }],
              [{ text: 'Total', colSpan: 4, fontSize: 12, bold: true, alignment: 'right' }, {}, {}, {}, { text: `₹${this.PendingOrder.ta.toFixed(2)}`, alignment: 'right', bold: true }]
            ]
          }
        },
        // {
        //   text: 'Additional Details',
        //   style: 'sectionHeader'
        // },
        // {
        //     text: this.invoice.additionalDetails,
        //     margin: [0, 0 ,0, 15]          
        // },
        {

          columns: [
            [{ text: 'Principal place of business: No.60, Ground Floor, RGM Complex, OMR IT Road, Rajiv Gandhi Salai, Karapakkam, Chennai, Tamil Nadu 600097.', italics: true, margin: [0, 30, 0, 30], color: 'grey' }],
          ]

        },
        {
          columns: [
            [{ text: 'www.fbcakes.com', alignment: 'center', italics: true, margin: [0, 30, 0, 30], link: 'www.fbcakes.com' }],
          ]
        },

        // {
        //   ul: [
        //     'Order can be return in max 10 days.',
        //     'Warrenty of the product will be subject to the manufacturer terms and conditions.',
        //     'This is system generated invoice.',
        //   ],
        // }
      ],
      styles: {
        sectionHeader: {
          bold: true,
          decoration: 'underline',
          fontSize: 14,
          margin: [0, 50, 0, 15]
        },
        boldsize: {
          bold: true,
          fontSize: 14,
        },

      }
    };
    // console.log(docDefinition)

    if (action === 'download') {
      pdfMake.createPdf(docDefinition).download('FBcakes_' + this.PendingOrder.ino + this.PendingOrder.Id);
      // console.log(docDefinition)
    }

  }
  @ViewChild('Reviewmodel', { static: true }) Reviewmodel: ElementRef<any>

  revieworddata: any
  allreviewdata: any
  reviewmodel(item, oi, cui) {
    // console.log(item)
    // console.log(oi, cui)
    this.revieworddata = item["product"]
    // console.log(this.revieworddata)
    this.externalService.GetReviews(this.revieworddata.id, oi, cui).subscribe(response => {
      // console.log(response)
      if (response != null) {
        this.textarea = response.desc
        this.rating = response.star
        this.imgreview = JSON.parse(response.img)
        this.modalService.open(this.Reviewmodel, { centered: true, size: 'l' });
        return response
      } else {
        this.modalService.open(this.Reviewmodel, { centered: true, size: 'l' });
      }

    })


  }

  rating: number = 0;
  stars: boolean[] = Array(5).fill(false);

  giveratings(rating: number): void {
    this.rating = rating;
    this.updateStars();
    // console.log(this.rating);
  }

  private updateStars(): void {
    this.stars = this.stars.map((_, index) => index < this.rating);
  }

  //Test image upload------------------------------------------------------------
  imgreview: any = []
  preview: any | ArrayBuffer | null = '';
  currentFile: File | null = null;
  message = '';
  selectFile(event: any): void {
    // console.log(event)
    this.message = '';
    this.preview = '';
    // console.log(this.preview)
    const selectedFiles = event.target.files;
    // console.log(selectedFiles)
    if (selectedFiles) {
      const file: File | null = selectedFiles.item(0);
      if (file) {
        if (file.size > 10000000) {
          this.message = 'File size exceeds the 10MB limit.';
          return;
        }
        this.currentFile = file;
        // console.log(this.currentFile)
        const reader = new FileReader();
        // console.log(reader)
        reader.onload = (e: any) => {
          var spl = { "url": e.target.result }
          this.preview = spl;
          // console.log(this.preview)
          this.imgreview.push(this.preview);
          this.preview = null;  // Clear preview after adding to imgs

          // console.log(this.imgreview)
        };
        reader.readAsDataURL(this.currentFile);
      }
    }
  }

  // Image remove--------------------------------------------------------------------------

  removeImage(index: number): void {
    // console.log(index)
    this.imgreview.splice(index, 1);

    // console.log(this.imgreview)
  }


  // Working Image Upload-------------------------------------------------------------------------

  textarea = ''
  disId = 0
  localReview: any = [];
  testimg: any = []
  url: any
  imgURL: any
  upload(files) {
    // console.log(files)
    this.testimg = files[0];
    var reader = new FileReader();
    // this.blobimageurl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(this.testimg).replace('unsafe:', ''));
    // console.log("File: ", files)
    // this.url = files;
    reader.readAsDataURL(files[0]); // read file as data url
    reader.onload = (event) => { // called once readAsDataURL is completed
      this.url = event.target.result;
      this.imgURL = this.url;
      // console.log(this.testimg)
      // console.log(this.imgURL)
      this.testimg.testurl = this.imgURL
      this.imgreview.push(this.testimg)
      // console.log("The File: ", this.testimg)
    }
  }


  post() {
    // console.log(this.imgURL)
    // console.log("The File: ", this.testimg)
    if (this.rating > 0) {
      // this.localReview = JSON.parse(localStorage.getItem("LocalReview")) || []
      const secid = localStorage.getItem("secid")
      // console.log(this.revieworddata)
      // console.log(this.PendingOrder)
      const data = {
        oid: this.PendingOrder.oi,
        pid: this.revieworddata.id,
        cid: this.PendingOrder.ca.custid,
        review: this.textarea,
        rating: this.rating,
        secid: secid,
        // img: this.imgreview,
        name: this.PendingOrder.ca.Name,
        city: this.PendingOrder.ca.City
      }
      // console.log(data)
      const savedata = JSON.stringify(data)
      // console.log(savedata)
      // console.log(this.imgreview)
      // // this.externalService.addReview(data)
      // console.log(this.imgreview[0].url)
      // console.log(this.imgreview[1].url)

      var postdata = { payload: JSON.stringify(savedata) };

      this.externalService.addReview(this.imgreview[0], this.imgreview[1], postdata).subscribe(response => {
        // console.log(response)
        this.modalService.dismissAll();
        if (response.status == 200) {
          // this.modalService.dismissAll();
          this.textarea = ''
          this.rating = 0
          this.imgreview = []
          this.toastrService.success('Success', 'Review Uploaded!')
        } else {
          this.toastrService.error('Error', 'Review Upload unsuccessful!')
        }

      })

      // this.localReview.push(data)
      // localStorage.setItem("LocalReview", JSON.stringify(this.localReview));

      // this.close()

    }
  }


  close() {
    this.textarea = ''
    this.rating = 0
    this.imgreview = []
    this.modalService.dismissAll();
  }


  // CancelOrder------------------------------------------------------------------------------------

  @ViewChild('Cancelord', { static: true }) Cancelord: ElementRef<any>

  cancelreason: string = ''
  hidecancelbtn: boolean = true
  cancelOrder() {
    this.modalService.open(this.Cancelord, { centered: true, size: 'l' });
  }


  valid() {
    var isvalid = true
    if (this.cancelreason.length < 40) isvalid = false
    return isvalid
  }

  submit: boolean = false

  SubmitCancelorder(item) {
    // console.log(item)
    this.submit = true
    if (this.valid()) {
      const secid = localStorage.getItem("secid")
      const cuid = localStorage.getItem("customerid")

      // console.log(this.cancelreason)
      const data = {
        oid: item.Id,
        orderId: item.oi || 0,
        reason: this.cancelreason,
        secid: secid,
        custid: cuid
      }
      // console.log(data)
      this.externalService.Cancelord(data).subscribe(response => {
        // console.log(response)
        if (response.status == 200) {
          this.modalService.dismissAll()
          this.cancelreason = ''
          this.toastrService.success('Success', 'Request Send Successful!')
          this.getorders()
          this.mainhide = false
          this.hide = false
          this.back()
        } else {
          this.toastrService.error('Error', 'Request Send Failed!')
        }
      })
      this.submit = false
    }

  }





  ipAddress: any;

  mylatlng: any = {
    lat: null,
    lng: null
  };
  getipadd() {
    // console.log('Attempting to retrieve location with high accuracy...');
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          // console.log('Position retrieved:', position);
          // console.log('Latitude:', position.coords.latitude);
          // console.log('Longitude:', position.coords.longitude);
          // console.log('Accuracy (meters):', position.coords.accuracy);
          this.mylatlng.lat = (position.coords.latitude + 0.0043774);
          this.mylatlng.lng = (position.coords.longitude + 0.0074004);
          const location = `https://www.google.com/maps/place/${this.mylatlng.lat},${this.mylatlng.lng}/@${this.mylatlng.lat},${this.mylatlng.lng},20z/`;
          // console.log('Google Maps URL:', location);
        },
        (error) => {
          // console.error('Error retrieving location:', error);
        },
        {
          enableHighAccuracy: true, // Request high accuracy
          timeout: 20000,           // Increase timeout to 20 seconds
          maximumAge: 0             // Ensure no cached position is used
        }
      );
    } else {
      alert('Geolocation is not supported by this browser.');
    }
  }







  // getipadd() {
  //   console.log('Fetching location...');
  //   if (navigator.geolocation) {
  //     navigator.geolocation.getCurrentPosition(
  //       (position) => {
  //         const lat = position.coords.latitude;
  //         const lng = position.coords.longitude;
  //         console.log(`Latitude: ${lat}, Longitude: ${lng}`);
  //         this.mylatlng = { lat, lng };

  //         const location = `https://www.google.com/maps/place/${lat},${lng}/@${lat},${lng},20z/`;
  //         console.log('Google Maps Link:', location);
  //       },
  //       (error) => {
  //         switch (error.code) {
  //           case error.PERMISSION_DENIED:
  //             console.error("User denied the request for Geolocation.");
  //             alert("Location access is denied.");
  //             break;
  //           case error.POSITION_UNAVAILABLE:
  //             console.error("Location information is unavailable.");
  //             alert("Location information is unavailable.");
  //             break;
  //           case error.TIMEOUT:
  //             console.error("The request to get user location timed out.");
  //             alert("Location request timed out.");
  //             break;
  //           default:
  //             console.error("An unknown error occurred.");
  //             alert("An unknown error occurred.");
  //             break;
  //         }
  //       },
  //       {
  //         enableHighAccuracy: true,
  //         timeout: 5000,
  //         maximumAge: 0
  //       }
  //     );
  //   } else {
  //     alert('Geolocation is not supported by this browser.');
  //   }
  // }



}













